var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "form-item radio",
          class: [_vm.isInvalid ? "is-invalid" : ""],
        },
        [
          _c("Label", {
            attrs: {
              item: _vm.item,
              "is-invalid": _vm.isInvalid,
              errors: _vm.errors,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            _vm._l(_vm.answeroptions, function (answer) {
              return _c("div", { key: answer.id }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    id: answer.id,
                    name: `${_vm.item.data.id}[]`,
                  },
                  domProps: { value: answer.label },
                  on: {
                    change: function ($event) {
                      return _vm.change($event, answer)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: answer.id } }, [
                  _vm._v(" " + _vm._s(answer.label) + " "),
                ]),
              ])
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }